import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthorisedSubNavLink } from '../../Auth/AuthorisedSubNavLink';
import { SubNavProps } from '../SubNavLinks';

type Props = SubNavProps;

const CampaignsSubNav: React.FC<Props> = props => {
  const { t } = useTranslation('campaigns');

  useEffect(() => {
    props.setHeading(t('label'));
  });

  const hasSite = props.clientId && props.level === 'sites';
  return (
    <>
      {hasSite && (
        <>
          <AuthorisedSubNavLink
            permissions={['ManageCampaigns']}
            to={`/${props.level}/${props.clientId}/campaigns/offsite`}
            icon="rocket"
            label={t('campaigns:offsite.label')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageCampaigns']}
            to={`/${props.level}/${props.clientId}/campaigns/onsite`}
            icon="rocket"
            label={t('campaigns:onsite.label')}
          />

          <AuthorisedSubNavLink
            permissions={['ManageCampaigns']}
            to={`/${props.level}/${props.clientId}/campaigns/campaigns`}
            icon="rocket"
            label={t('campaigns:mps.label')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageCampaigns']}
            featureFlag={'split-tests'}
            to={`/${props.level}/${props.clientId}/campaigns/split_tests`}
            icon="rocket"
            label={t('campaigns:splitTests')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageCampaigns']}
            to={`/${props.level}/${props.clientId}/campaigns/bulk-retargeting`}
            icon="rocket"
            label={t('campaigns:bulkReTargeting')}
          />
        </>
      )}
    </>
  );
};
export default CampaignsSubNav;
